export default __webpack_public_path__ + "assets/02d.9a86613b.svg";